// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';


import * as serviceSelectors from './selectors';
import * as serviceActions from './actions';

import * as Formatters from '../ui/Formatters';
import * as MessageFormat from './MessageFormat';
import LinkedText from '../ui/LinkedText';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
  ...MessageFormat.styles(theme),
});


/*
 * Format for an plain Text and SMS
 */
class TextFormat extends Component {

  formatTime = (duration) => {
    if(duration < 60){
      // return '00:00:' + duration < 10 ? '0' + duration : duration;
      return `00:00:${duration < 10 ? '0' + String(duration) : String(duration)}`
    } else if(duration < 60*60) {
      let min = parseInt(duration/60);
      let sec = parseInt(duration - (min*60));
      return `00:${min < 10 ? '0' + String(min): String(min)}:${sec < 10 ? '0' + String(sec): String(sec)}`
    } else {
      let hour = parseInt(duration/(60*60));
      let min = parseInt((duration - (hour*60*60))/60);
      let sec = parseInt(duration - (min*60) - (hour*60*60));
      return `${hour < 10 ? '0' + String(hour): String(hour)}:${min < 10 ? '0' + String(min): String(min)}:${sec < 10 ? '0' + String(sec): String(sec)}`
    }
  }

  render() {
    /* eslint-disable */
    const { classes, message,t } = this.props;

    let sender;
    if (Boolean(message.sendingUser)) {
      sender='Text message from ' + message.sendingUser;
    } else {
      if (Boolean(message.sendingAgent)) {
        sender='Text message from Ruby staff member ' + message.sendingAgent;
      }
    }

    return (
      <div className={classes.formatTop}>
        <div className={classes.messageSender}>
          {sender}
        </div>
        <div className={classes.taken}>
          {Formatters.formatDateTime(message.taken)}
        </div>
        <div className={classes.taken}>
          Reference ID: {message.messageId}
        </div>
        <div className={classes.taken}>
          Contact Description: {message.contactDescription}
        </div>

        <div className={classes.sectionHeader}>
          Text
        </div>

        <MuiCore.Divider/>

        <div className={classes.fieldData} style={{ whiteSpace: 'pre-wrap' }}>
          <LinkedText value={message.textContent} onClick={this.props.openContactLink}/>
        </div>

        <MuiCore.Grid item>
              <div className={classes.sectionHeader} style={{marginTop: 20}}>
                Duration
              </div>
              <div style={{fontFamily: 'Sofia'}}>
                  Receptionist Time: {message.billableAgentMinutes !== undefined ? this.formatTime(message.billableAgentMinutes * 60) : '00:00:00'}
              </div>
          </MuiCore.Grid>

        <MuiCore.Hidden xlDown={!message.request}>
          <div className={classes.sectionHeader}>
          {t('Assist')} Request
          </div>
          <MuiCore.Divider/>
          
          <div className={classes.fieldData} style={{ whiteSpace: 'pre-wrap' }}>
            <LinkedText value={message.request} onClick={this.props.openContactLink}/>
          </div>
        </MuiCore.Hidden>

        <MessageFormat.MessageStatus
          message={message}
          sectionHeaderClass={classes.sectionHeader}
          fieldLabelClass={classes.fieldLabel}
          fieldDataClass={classes.fieldData}/>       
        
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    message : serviceSelectors.getMessage(state),
  });
};

const mapDispatchToProps = {
  openContactLink : serviceActions.openContactLink,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withTranslation()(TextFormat)));